<template>
  <section class="container">
    <h1> {{c}} </h1>
    <div class="input-field ">
        <select v-model="opciones" class="select-vista-cripto" ref="seleccionado">
            <option >1</option>
            <option >1</option>
            <option >1</option>
            <option >1</option>
        </select>
     <label>Vista</label>
    </div>
    <div class="columns">
      <div class="chart-container">
        <canvas class="chartjs-render-monitor" ref="canvas"></canvas>
      </div>
    </div>
  </section>
</template>
<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  type: 'horizontalBar',
  data: () => ({
    c: '',
    opciones: '',
    chartdata: {
      labels: [],
      datasets: [
        {
          label: 'Data One',
          backgroundColor: '#f87979',
          data: []
        }
      ]
    },
    options: {
      responsive: true,
      devicePixelRatio: 1,
      maintainAspectRatio: true,
      legend: {
        display: false
      },
      responsiveAnimationDuration: 0,
      aspectRatio: 1,
      animation: {
        duration: 0
      },
      hover: {
        animationDuration: 0
      }
    }
  }),
  methods: {
    renderChart2: (res, c) => {
      var price = res.price
      var bid = res.bid
      var ask = res.ask
      var data = ask
        .concat([ { fin: price, precentDif: c / 100 } ])
        .concat(bid)
      let labels = data.map(item => item.fin + ' --- ' + (item.precentDif * 100).toFixed(2) + '%')
      let datasets = [{
        label: 'data',
        backgroundColor: data.map(item => (price > item.inicio) ? 'red' : 'green'),
        data: data.map(item => item.value)
      }]
      return { labels, datasets }
    }
  },
  mounted () {
    let me = this
    this.renderChart(this.chartdata, this.options)
    var urlString = window.location.href
    console.log(urlString, 'url-string')
    var url = new URL(urlString)
    this.c = url.searchParams.get('symbol')
    let ws = new WebSocket(`${process.env.BROADCAST_DRIVER}?symbol=${this.c}`)
    ws.onopen = function () {
      ws.send('connected')
    }
    ws.onmessage = async function (ev) {
      let res = JSON.parse(ev.data)
      var data = me.renderChart2(res.barras, res.c)
      await me.renderChart(data, me.options)
    }
  }
}
</script>

<style>
.container{
  padding-top: 5%;
}

.chart-container {
  display: block;
  position: relative;
  margin: auto;
  height: 50vh !important;
  width: 80vw !important;
}

.select-vista-cripto{
  /* border: 1px solid red; */
  width: 10%;
}

</style>



// WEBPACK FOOTER //
// src/components/grafica.vue